import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPackagesInShop } from '../../actions/selector';
import { ShoppingCartState } from '../../actions/standalone';

@Pipe({
    name: 'namePacket',
    standalone: false
})
export class NamePacketPipe implements PipeTransform {
  packetsList$ = this.store.pipe(select(selectPackagesInShop));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(packetId: string) {
    let name = '';
    this.packetsList$.subscribe((packets) => {
      name = packets.package.find(
        (packet) => packet.packageId === packetId
      )?.name;
    });
    return name;
  }
}
